import React, {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router'
import Swal from 'sweetalert2'
import {
  adminUpdateKYC,
  getAdminKYCDetails,
  getBusinessTypeList,
  getKYCAccountDocType,
} from './ApproveKYCAPI'
import {countryDataType, provinceDataType} from '../../property/PropertyDataTypes'
import {Get_Country, Get_Province} from '../../property/Property_Api'
import {useFormik} from 'formik'
import {CircularProgress} from '@mui/material'
import {AdminUpdateKYCinitialValues} from './ApproveKYCInitialValues'
import {adminUpdateKYCDetailsValidationSchema} from './ApproveKYCValidationSchema'
import UploadDocuments from './Components/UploadDocuments'
import KYCBasicForm from './Components/KYCBasicForm'
import UserUploadedDoc from './Components/UserUploadedDoc'
import UploadedDocTable from './Components/UploadedDocTable'
import KYCStatusSection from './Components/KYCStatusSection'
import {
  adminKYCAPIDocDataType,
  adminKYCDetailsDataType,
  adminBusinessTypeDataType,
  adminKYCAccountDocTypeDataType,
  adminKYCDocDataType,
  adminUploadDocumentsArrayDataType,
} from './ApproveKYCDataType'

const ApproveKYCDetail = () => {
  const {id} = useParams()
  const navigate = useNavigate()
  const [kycDetails, setKycDetails] = useState<adminKYCDetailsDataType>()
  const [submitBtnLoading, setSubmitBtnLoading] = useState<boolean>(false)
  const [country, setCountry] = useState<countryDataType[]>()
  const [province, setProvince] = useState<provinceDataType[]>([])
  const [businessType, setBusinessType] = useState<adminBusinessTypeDataType[]>([])
  const [APIDataKYCAccountDocType, setAPIDataKYCAccountDocType] = useState<
    adminKYCAccountDocTypeDataType[]
  >([])
  const [KYCAccountDocType, setKYCAccountDocType] = useState<adminKYCAccountDocTypeDataType[]>([])
  const [uploadDocuments, setUploadDocuments] = useState<adminUploadDocumentsArrayDataType[]>([])
  const [showKYCDoc, setShowKYCDoc] = useState<adminKYCAPIDocDataType | null>(null)
  const [loading, setLoading] = useState<boolean>(true)

  // function to view the partivular KYC based on account_kyc_uuid
  async function getKYCDetails() {
    if (id) {
      try {
        const {data: response} = await getAdminKYCDetails(id)
        if (response.code === '200') {
          setKycDetails(response.data)
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
            text: response.msg_details,
            allowOutsideClick: true,
          })
        }
      } catch (error: any) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error,
        })
      }
    }
  }
  // function to get country
  async function getCountry() {
    try {
      const {data: res} = await Get_Country()
      if (res.code === '200') {
        setCountry(res.data)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
          text: res.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    }
  }
  // function to get Province/state
  async function getProvince(country: number) {
    try {
      const {data: res} = await Get_Province(country)
      if (res.code === '200') {
        setProvince(res.data)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
          text: res.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    }
  }
  // function to get business type
  async function getBusinessType() {
    try {
      const {data: res} = await getBusinessTypeList()
      if (res.code === '200') {
        setBusinessType(res.data)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
          text: res.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    }
  }
  // function to get KYC Account Doc type
  async function getKYCAccountDocumentType() {
    try {
      const {data: res} = await getKYCAccountDocType()
      if (res.code === '200') {
        setKYCAccountDocType(res.data)
        setAPIDataKYCAccountDocType(res.data)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
          text: res.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    }
  }
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        await Promise.all([
          getCountry(),
          getBusinessType(),
          getKYCAccountDocumentType(),
          getKYCDetails(),
        ])
      } catch (error: any) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error,
        })
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [])
  useEffect(() => {
    if (kycDetails?.country_id && typeof kycDetails?.country_id === 'number') {
      getProvince(kycDetails?.country_id)
    }
  }, [kycDetails?.country_id])

  const formik = useFormik({
    initialValues: kycDetails
      ? {...kycDetails, confirm_account_no: kycDetails.account_no}
      : AdminUpdateKYCinitialValues,
    enableReinitialize: true,
    validationSchema: adminUpdateKYCDetailsValidationSchema,
    onSubmit: (values) => {
      handleUpdateKYC(values)
    },
  })

  // function to create KYC onSubmit
  const handleUpdateKYC = async (values: adminKYCDetailsDataType) => {
    let kyc_docs: adminKYCDocDataType[] = []
    if (uploadDocuments.length > 0) {
      kyc_docs = uploadDocuments.map(({account_kyc_document_type_uuid, file}) => ({
        account_kyc_document_type_uuid,
        file,
      }))
    }
    setSubmitBtnLoading(true)
    try {
      const {data: res} = await adminUpdateKYC(
        values.account_kyc_uuid ? values.account_kyc_uuid : id,
        values.account_kyc_name,
        values.business_registartion_type_uuid,
        values.business_name,
        values.address_1,
        values.address_2,
        typeof values.country_id === 'string' ? parseInt(values.country_id, 10) : values.country_id,
        typeof values.province_id === 'string'
          ? parseInt(values.province_id, 10)
          : values.province_id,
        values.city,
        values.pin_zip,
        values.account_holder_name,
        values.account_no,
        values.ifsc_swift_code,
        values.account_email_id,
        values.account_phone_number,
        typeof values.account_kyc_status === 'string'
          ? parseInt(values.account_kyc_status, 10)
          : values.account_kyc_status,
        kyc_docs
      )
      if (res.code === '200') {
        formik.resetForm()
        setUploadDocuments([])
        setKYCAccountDocType(APIDataKYCAccountDocType)
        navigate('/approve_kyc')
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
          text: res.msg_details,
          allowOutsideClick: true,
        })
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
          text: res.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
        allowOutsideClick: true,
      })
    } finally {
      setSubmitBtnLoading(false)
    }
  }

  // address code starts
  // function to handle change in country
  const handleChangeCountry = (val: string) => {
    getProvince(Number(val))
    formik.setFieldValue('province_id', '', true)
    formik.setFieldValue('country_id', val, true)
  }
  // Address code ends

  return (
    <>
      {loading ? (
        // {* Begin: loader*}
        <div
          className='d-flex justify-content-center align-items-center vh-70'
          style={{height: '70vh'}}
        >
          <CircularProgress />
        </div>
      ) : (
        // {* End: loader*}
        <div className='app-main flex-column flex-row-fluid'>
          {/* Begin: KYC Details Heading  */}
          <div className='d-flex align-items-center gap-2 gap-lg-3 justify-content-between mb-5 px-5'>
            <h2
              className='page-heading d-flex text-dark fw-bold fs-3 my-0
        flex-column justify-content-center'
            >
              KYC Details
            </h2>
          </div>
          {/* End: KYC Details Heading  */}
          {/* Begin: form */}
          <form onSubmit={formik.handleSubmit} className='p-10 card-body card mb-5 mb-xl-8'>
            {/* Begin: basic form for kyc */}
            <KYCBasicForm
              formik={formik}
              businessType={businessType}
              handleChangeCountry={handleChangeCountry}
              country={country}
              province={province}
            />
            {/* End: basic form for kyc */}

            <UserUploadedDoc
              kycDetails={kycDetails}
              showKYCDoc={showKYCDoc}
              setShowKYCDoc={setShowKYCDoc}
            />

            {/* Begin: Section for documents uploaded by user */}

            {/* End: Section for documents uploaded by user */}

            {/* Begin: Document upload section */}
            {KYCAccountDocType.length > 0 && (
              <>
                <hr className='py-2 text-primary' />
                {/* Begin: heading for document upload section */}
                <h2 className='text-center page-heading text-primary fw-bold fs-3 mb-4'>
                  Document upload
                </h2>
                {/* End: heading for document upload section */}
                {/* Begin: Document upload section by super-admin */}
                <UploadDocuments
                  formik={formik}
                  KYCAccountDocType={KYCAccountDocType}
                  setKYCAccountDocType={setKYCAccountDocType}
                  uploadDocuments={uploadDocuments}
                  setUploadDocuments={setUploadDocuments}
                />
                {/* End: Document upload section by super-admin */}
              </>
            )}
            {/* End: Document upload section */}

            {/* Begin: uploaded Document by super-admin section */}
            {uploadDocuments.length > 0 && (
              <>
                <hr className='pt-2 text-primary' />
                {/* Begin: uploaded documents heading */}
                <h2 className='text-center page-heading text-primary fw-bold fs-3'>
                  Uploaded documents
                </h2>
                {/* End: uploaded documents heading */}
                {/* Begin: uploaded documents table by super-admin table */}
                <UploadedDocTable
                  uploadDocuments={uploadDocuments}
                  setUploadDocuments={setUploadDocuments}
                  APIDataKYCAccountDocType={APIDataKYCAccountDocType}
                  setKYCAccountDocType={setKYCAccountDocType}
                  KYCAccountDocType={KYCAccountDocType}
                />
                {/* Begin: uploaded documents table by super-admin table */}
              </>
            )}
            {/* End: uploaded Document by super-admin section */}

            {/* Begin: KYC status section */}
            <KYCStatusSection formik={formik} kycDetails={kycDetails} />
            {/* End: KYC status section */}
            <div className='d-flex justify-content-center'>
              {/* Begin:: submit button */}
              <button
                type='submit'
                className='btn btn-lg btn-primary mt-5'
                data-kt-stepper-action='submit'
                disabled={submitBtnLoading}
              >
                {submitBtnLoading ? (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Processing...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                ) : (
                  'Submit'
                )}
              </button>
              {/* Begin:: submit button */}
            </div>
          </form>
          {/* End: form */}
        </div>
      )}
    </>
  )
}

export default ApproveKYCDetail
